"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._serialize = void 0;
const getYupProxy_1 = require("./getYupProxy");
const _serialize = (schemaBuilder) => {
    const yupProxy = (0, getYupProxy_1.getYupProxy)();
    const builtResult = schemaBuilder(yupProxy);
    return {
        serializedYupCall: builtResult.__path,
        jsonRepresentedValidation: builtResult.__json_representation,
        argumentMap: builtResult.__argumentMap,
    };
};
exports._serialize = _serialize;
